import React, { FunctionComponent, useState } from 'react';

import {
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

type Props = {
  open: boolean;
  setOpen: (f:boolean) => void;
};

export const AlertDestroyed: FunctionComponent<Props> = ({open, setOpen}) => {
  const [snackOpen, setSnackOpen] = useState<boolean>(open);

  return (<>
    <Snackbar
      open={snackOpen}
      onClose={() => {setSnackOpen(false); if (!!setOpen) setOpen(false);}}
      autoHideDuration={2000}
    >
      <MuiAlert elevation={6} variant="filled" severity="success">
        Destroyed!
      </MuiAlert>
    </Snackbar>
  </>);
}